export default import.meta.ROLLDOWN_FILE_URL_$PseplJ0WqW_8kNjnxhaKw